<template>
    <div>
        <div class="row mt-3">
            <div class="col-12">
                <div class="pull-right">
                    <a :href="reports_list_route">
                        <button class="btn btn-default float-left" type="button">{{ $lang('Wróć') }}</button>
                    </a>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <form id="reportForm" class="my-2">
                    <dora-inputs
                        v-on:validation="validation"
                        :libraries="libraries"
                        :statuses="statuses"
                        :is-admin="isAdmin"
                    ></dora-inputs>
                </form>
            </div>
        </div>


        <div class="row" >
            <div class="col-12">
                <button class="float-right btn btn-primary mt-3 mb-3" type="button" v-on:click="exportFile()">
                    {{$lang('Eksport XLSX')}}
                </button>
            </div>
        </div>
        <generating-modal></generating-modal>
    </div>
</template>

<script>

import ReportMethods from "../../../mixins/reports";
import GeneratingModal from "../../generating-modal";
import DoraInputs from "./dora-inputs.vue";

export default {
    name: 'dora-template',
    components: {DoraInputs, GeneratingModal},
    mixins: [ReportMethods],
    props: {
        libraries: Array,
        statuses: Array,
        isAdmin: Boolean
    },
    data() {
        return {

        }
    },
    methods: {
        exportFile() {
            let form = new FormData(document.getElementById('reportForm'));
            this.exportExcel(form);
        }
    }
}
</script>
